import { getLocalTimeZone } from "@internationalized/date";

// TODO: Should we use local timezone here?
/** All dates will be considered to be in this timezone */
export const defaultTz = getLocalTimeZone();
